class roles {
  constructor(id, name, description) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.actions = undefined
  }
  static fromJson({ rolId, nombre, descripcion }) {
    return new roles(rolId, nombre, descripcion);
  }
}
export default roles


